/** 에러 메시지 알럿창 - 공통 */

interface IProps {
  status?: unknown | string;
  dataError?: unknown | string;
  koMessage?: unknown | string;
}

const ErrorMessage = (status: IProps, dataError: IProps) => {
  console.log(`status: ${status} / data: ${JSON.stringify(dataError)}`);
  alert(`error message: ${JSON.stringify(dataError?.koMessage)}`);
  return false;
};

export default ErrorMessage;
